<template>
  <div>
    <span v-if="message.message">{{ message.message }}</span>
    <div class="rule" :class="[resolutionOptionsPosition, { disabled: isResolved }]">
      <div class="item" @click="handleResolve(message, true)">
        <span>{{ positionOptionText }}</span>
      </div>
      <div class="item" @click="handleResolve(message, false)">
        <span>{{ negativeOptionText }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { MessageType, SystemEvent } from '@/common/bot/enum';
import { ResolutionMessageType, ResolutionType } from '@/common/bot/enum/ResolutionType';
import { BaseSystemMessage, ResolutionEvent, ResolutionMessage } from '@/common/bot/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { RESOLUTION_OPTIONS_POSITION, resolutionOptionsText } from './resolutionConfig';

/*
  This component is used to display a resolution message to the user.
  The user can choose between two options: "Yes" and "No".
  Customized text for these options is defined in the resolutionConfig file.
  The user's choice is sent to the bot as a ResolutionEvent.
*/
@Component({})
export default class ResolutionMessageComponent extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  private isResolved = false;

  get resolutionOptionText() {
    const messageType = this.message.type as unknown as ResolutionMessageType;
    return resolutionOptionsText(messageType);
  }

  get positionOptionText() {
    return this.resolutionOptionText[ResolutionType.YES];
  }

  get negativeOptionText() {
    return this.resolutionOptionText[ResolutionType.NO];
  }

  get resolutionOptionsPosition() {
    const messageType = this.message.type as unknown as ResolutionMessageType;
    const position = RESOLUTION_OPTIONS_POSITION[messageType];
    return position || RESOLUTION_OPTIONS_POSITION[MessageType.RESOLUTION]!;
  }

  handleResolve(message: ResolutionMessage, resolved: boolean) {
    if (this.isResolved) return;
    this.isResolved = true;

    const event: ResolutionEvent = {
      message,
      type: SystemEvent.USER_RESOLUTION_SELECTED,
      payload: { selected: resolved ? 'yes' : 'no' },
    };

    this.$emit('send:event', event);
  }
}
</script>

<style scoped lang="scss">
@import '../ActionButtonCommon.scss';

.row {
  display: flex;
  flex-direction: row;
}

.column {
  display: flex;
  flex-direction: column;
}

.rule.disabled {
  pointer-events: none;
  opacity: 0.7;
}
</style>
